<form name="form" #form="ngForm" class="component-dialog-style" (submit)="submit()">

	<div class="modal-header">
		<div class="header-title" id="modal-title">
			{{ 'Event_QA_Action_Reply' | translate }}
		</div>
		<button type="button" class="close btn btn-transparent" (click)="cancel()" [attr.aria-label]="'Close' | translate">
		<span class="glyphicons remove_2"></span>
	</button>
	</div>

	<div class="modal-body">
		<div class="d-flex margin-bottom-10">
			<span class="lh-sm">{{ 'Event_QA_ReplyingToQuestion' | translate }}:</span>
			<p class="padding-left-10 lh-sm" [ngClass]="styles.questionWrapper" [innerHTML]="question.questionText | safeHtml"></p>
		</div>
		<vb-ui-html-editor name="replyText" [attr.aria-label]="'Event_QA_ReplyingToQuestion' | translate" [(ngModel)]="replyText" required [editorConfig]="editorConfig" [themedToolbarMode]="true" [autoFocus]="true">
		</vb-ui-html-editor>
	</div>

	<div class="modal-footer align-items-center">
		<div class="d-flex me-auto align-items-center">
			<vb-toggle-button name="isPublicChkBox" [ariaLabel]="'Event_QuestionReplyPublishToAll' | translate" [(ngModel)]="isPublic">
			</vb-toggle-button>
			<span [tooltip]="'Event_QuestionReplyPublishTooltip' | translate" [placement]="'top left'">
				{{ 'Event_QuestionReplyPublishToAll' | translate }}
			</span>
		</div>
		<button type="button" vbBtnSecondary (click)="cancel()" class="margin-right-10">{{ 'Cancel' | translate }}</button>
		<button type="submit" vbBtnPrimary [disabled]="form.invalid">{{ 'Reply' | translate }}</button>
	</div>
</form>
